import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';
const PAGE_SIZE = 20;

function AdminUsers() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(true);

  const totalPages = Math.ceil(total / PAGE_SIZE);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const offset = (page - 1) * PAGE_SIZE;
      const params = new URLSearchParams({ limit: PAGE_SIZE, offset });
      if (search) params.set('search', search);
      const res = await fetch(`${API_BASE_URL}/admin/users?${params}`, {
        headers: { 'Authorization': `Bearer ${session.access_token}` }
      });
      const result = await res.json();
      if (result.success) {
        setUsers(result.data.users);
        setTotal(result.data.total);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [session, page, search]);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setSearch(searchInput);
  };

  const fmtMoney = (n) => `¥${(parseFloat(n) || 0).toFixed(2)}`;
  const fmtDate = (t) => new Date(t).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' });

  return (
    <div>
      <div className="ad-term">
        <div className="ad-term-bar">
          <div className="ad-term-dots">
            <span className="ad-term-dot ad-term-dot--red" />
            <span className="ad-term-dot ad-term-dot--yellow" />
            <span className="ad-term-dot ad-term-dot--green" />
          </div>
          <span className="ad-term-title">users — {total} 条记录</span>
        </div>
        <div className="ad-term-body">
          <form className="ad-toolbar" onSubmit={handleSearch}>
            <input
              className="ad-search-input"
              type="text"
              placeholder="搜索邮箱..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="ad-filter-btn" type="submit">搜索</button>
            {search && (
              <button className="ad-filter-btn" type="button" onClick={() => { setSearchInput(''); setSearch(''); setPage(1); }}>
                清除
              </button>
            )}
          </form>

          {loading ? (
            <div className="ad-loading">加载中...</div>
          ) : users.length === 0 ? (
            <div className="ad-empty">暂无用户</div>
          ) : (
            <>
              <div className="ad-table-wrap">
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>邮箱</th>
                      <th>余额</th>
                      <th>冻结</th>
                      <th>任务数</th>
                      <th>注册时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(u => (
                      <tr key={u.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/admin/users/${u.id}`)}>
                        <td><span className="ad-table-link">{u.email}</span></td>
                        <td>{fmtMoney(u.balance)}</td>
                        <td>{fmtMoney(u.frozen_balance)}</td>
                        <td>{u.task_count || 0}</td>
                        <td>{fmtDate(u.created_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="ad-pagination">
                  <button className="ad-page-btn" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>上一页</button>
                  <span className="ad-page-info">{page} / {totalPages}</span>
                  <button className="ad-page-btn" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>下一页</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminUsers;
